var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96875 5.1875H7.21875H6.53125V3.8125H7.21875H8.29297L7.92773 3.44727C6.57422 2.11523 4.4043 2.11523 3.05078 3.44727C1.71875 4.80078 1.71875 6.9707 3.05078 8.32422C4.4043 9.65625 6.57422 9.65625 7.92773 8.32422L8.89453 9.29102C7.00391 11.1602 3.97461 11.1602 2.08398 9.29102C0.214844 7.40039 0.214844 4.37109 2.08398 2.48047C3.97461 0.611328 7.00391 0.611328 8.89453 2.48047L9.28125 2.86719V1.75V1.0625H10.6562V1.75V4.5V5.1875H9.96875Z",
    fill: "#3A8FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/update-icon.12faed4786bc01b8841fb3c6d332003f.svg";
export { ForwardRef as ReactComponent };